import React, { useState, useRef } from "react";
import { useIntl } from "react-intl";
import { Input, Button } from "@masterteam/mt-design-react";

import { ReactComponent as CloseIcon } from "../../assets/images/close.svg";

import styles from "./AdminSearch.module.scss";

function AdminSearch({ value, onChange, disabled, requireSubmit }) {
  const inputRef = useRef();
  const intl = useIntl();
  const [searchText, setSearchText] = useState(value || "");

  return (
    <div className={styles.searchBar}>
      <Button
        disabled={disabled}
        className={styles.searchBtn}
        variant="secondary"
        onClick={() => onChange(searchText)}
      >
        {intl.formatMessage({ id: "common.search" })}
      </Button>
      <Input
        disabled={disabled}
        ref={inputRef}
        type="text"
        value={searchText}
        style={{
          border: "none",
          height: "100%",
          width: "200px",
        }}
        onChange={(event) => {
          setSearchText(event.target.value);
          if (!requireSubmit) return onChange(event.target.value);
        }}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            onChange(searchText);
          }
        }}
      />
      <Button
        disabled={disabled}
        className={styles.clearBtn}
        fill="none"
        variant="dark"
        shape="square"
        size="small"
        Icon={CloseIcon}
        onClick={() => {
          inputRef.current?.focus();
          setSearchText("");
          onChange("");
        }}
      />
    </div>
  );
}

export default AdminSearch;
